module.exports = __webpack_public_path__ + "img/201603-1-1024x1024.9ebb9416.png";